var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"steps-list-item",class:{ 'is-active': _vm.active }},[_c('span',{staticClass:"steps-list-item__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }